import { Box, Button, Typography } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { CustomEvent } from "schemas/functions";

import StyledTextField from "components/Styled/TextField";

import styles from "../styles";

interface Props {
  pendingSample: string;
  setPendingSample: Dispatch<SetStateAction<string>>;
  samples: string[];
  onSamplesChange: (samples: string[]) => void;
}

export function PasteSamples({
  pendingSample,
  setPendingSample,
  samples,
  onSamplesChange,
}: Props) {
  const addSample = () => {
    const trimmed = pendingSample.trim();
    if (!trimmed) return;
    onSamplesChange([...samples, trimmed]);
    setPendingSample("");
  };

  const removeSample = (idx: number) => {
    onSamplesChange(samples.filter((_, i) => i !== idx));
  };

  return (
    <Box>
      <StyledTextField
        fullWidth
        multiline
        minRows={3}
        placeholder="Paste a cold outreach email you've already sent, a pitch you wrote, or any message that sounds like you. The longer and more natural, the better Bento can match your voice."
        value={pendingSample}
        onChange={(e: CustomEvent) => setPendingSample(e.target.value)}
      />
      <Box sx={styles.writingSampleAddButton}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
          Add as many as you'd like.
        </Typography>
        <Button
          size="small"
          startIcon={<Box component="i" className="fa-solid fa-plus" />}
          disabled={pendingSample.trim().length === 0}
          onClick={addSample}
        >
          Add sample
        </Button>
      </Box>

      {samples.length > 0 && (
        <Box sx={styles.writingSampleList}>
          {samples.map((sample, idx) => (
            <Box key={idx} sx={styles.writingSampleRow}>
              <Box sx={styles.writingSampleContent}>
                <Typography sx={styles.writingSampleLabel}>
                  {`Writing sample #${idx + 1}`}
                </Typography>
                <Typography sx={styles.writingSampleText}>{sample}</Typography>
              </Box>
              <Button
                sx={styles.writingSampleRemoveButton}
                onClick={() => removeSample(idx)}
                aria-label="Remove sample"
              >
                <Box component="i" className="fa-regular fa-xmark" />
              </Button>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}

export default PasteSamples;
